'use strict';

customerZone.service('LightToFullService', ['OrderService', function(OrderService){
    var self = this;

    self.isMigrating = function(){
        return OrderService.getAllOrdersOfType('light_to_full_migration')
            .then(function(result){
                return !!(result[0]);
            });
    };
}]);
